(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7429],{

/***/ 77349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ system_riadenia_kvality_vzdelavania; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/EducationQualityManagementSystem/EducationQualityManagementSystem.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationQualityManagementSystemelements__Wrapper",
  componentId: "sc-1ks31wi-0"
})(["margin-top:", ";padding:0 ", ";@media (min-width:", "px){margin-top:", ";}.title{font-size:", ";font-weight:", ";color:", ";display:block;text-align:center;padding-bottom:", ";margin-top:", ";}.subTitle{font-weight:", ";display:block;text-align:center;padding-bottom:", ";}h1.sectionTitle{font-size:", ";font-weight:", ";display:block;padding:", " 0;}h2.sectionTitle{font-size:", ";font-weight:", ";display:block;padding:", " 0;}.underline{text-decoration:underline;}.marginLeft{margin-left:", ";}.section{a{color:", ";padding-right:", ";display:inline-flex;}}"], (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(65), function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(18), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(16), function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(4));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/EducationQualityManagementSystem/EducationQualityManagementSystem.tsx




var EDUCATION_QUALITY_MANAGEMENT_SYSTEM_ID = 'EducationQualityManagementSystem';

var EducationQualityManagementSystemTemplate = function EducationQualityManagementSystemTemplate() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "title",
      id: "".concat(EDUCATION_QUALITY_MANAGEMENT_SYSTEM_ID, "-sekcia"),
      children: "Intern\xE1 smernica riadenia a zabezpe\u010Dovania kvality vzdel\xE1vania"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "subTitle",
      children: "Poradca podnikate\u013Ea, s. r. o. \u2013 \xFAsek Vzdel\xE1vanie, platforma Profivzdel\xE1vanie.sk"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "1. \xDA\u010Del smernice"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["\xDA\u010Delom tejto internej smernice je detailne upravi\u0165 procesy, princ\xEDpy a \u0161tandardy riadenia kvality vzdel\xE1vania poskytovan\xE9ho spolo\u010Dnos\u0165ou ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Poradca podnikate\u013Ea, s. r. o.,"
      }), " prostredn\xEDctvom platformy ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Profivzdel\xE1vanie.sk"
      }), ". Dokument predstavuje z\xE1kladn\xFD pilier syst\xE9mu riadenia kvality a stanovuje jednotn\xFD r\xE1mec, ktor\xFD zabezpe\u010Duje transparentnos\u0165, odborn\xFA \xFArove\u0148, pr\xE1vnu bezchybnos\u0165 a vysok\xFA pou\u017E\xEDvate\u013Esk\xFA hodnotu vzdel\xE1vac\xEDch v\xFDstupov."]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "2. P\xF4sobnos\u0165 smernice"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["T\xE1to smernica sa vz\u0165ahuje na v\u0161etky osoby, ktor\xE9 sa podie\u013Eaj\xFA na pl\xE1novan\xED, pr\xEDprave, realiz\xE1cii, administr\xE1cii alebo hodnoten\xED vzdel\xE1vac\xEDch aktiv\xEDt v r\xE1mci platformy ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Profivzdel\xE1vanie.sk "
      }), "v\xA0spolo\u010Dnosti ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Poradca podnikate\u013Ea, s. r. o."
      }), ", \xFAsek Vzdel\xE1vanie. P\xF4sobnos\u0165 smernice sa vz\u0165ahuje nielen na intern\xFDch zamestnancov, ale aj na extern\xFDch spolupracovn\xEDkov, ktor\xED vykon\xE1vaj\xFA odborn\xFA, technick\xFA alebo z\xE1kazn\xEDcku podporu."]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Smernica sa uplat\u0148uje pri v\u0161etk\xFDch druhoch vzdel\xE1vac\xEDch aktiv\xEDt, pri\u010Dom ka\u017Ed\xE1 forma m\xE1 svoje \u0161pecifik\xE1, ktor\xE9 musia by\u0165 zoh\u013Eadnen\xE9 pri pl\xE1novan\xED, realiz\xE1cii aj vyhodnocovan\xED:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "online kurzy a videokurzy"
        }), " \u2013 obsahuj\xFA vopred pripraven\xFD audiovizu\xE1lny materi\xE1l, ktor\xFD mus\xED sp\u013A\u0148a\u0165 technick\xE9 a didaktick\xE9 \u0161tandardy,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "webin\xE1re/online \u0161kolenia"
        }), " \u2013 synchr\xF3nna forma vzdel\xE1vania, ktor\xE1 si vy\u017Eaduje d\xF4sledn\xFA technick\xFA pr\xEDpravu a riadenie interakcie s \xFA\u010Dastn\xEDkmi,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "prezen\u010Dn\xE9 \u0161kolenia"
        }), " \u2013 zameran\xE9 na priamu pr\xE1cu s \xFA\u010Dastn\xEDkmi, s d\xF4razom na bezpe\u010Dnos\u0165, didaktiku a organiza\u010Dn\xFA pripravenos\u0165,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "odborn\xE9 konferencie"
        }), " \u2013 viaczdrojov\xE9 podujatia, na ktor\xFDch mus\xED by\u0165 zabezpe\u010Den\xE1 odborn\xE1 garancia v\u0161etk\xFDch blokov,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "hybridn\xE9 formy vzdel\xE1vania"
        }), " \u2013 kombin\xE1cia prezen\u010Dnej a online formy, ktor\xE1 vy\u017Eaduje zv\xFD\u0161en\xFA koordin\xE1ciu technick\xFDch a organiza\u010Dn\xFDch prvkov."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "3. Defin\xEDcie pojmov"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "3.1 Vzdel\xE1vacia aktivita"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Vzdel\xE1vacia aktivita je odborn\xFD program ur\u010Den\xFD na vzdel\xE1vanie dospel\xFDch, rozvoj pracovn\xFDch kompetenci\xED alebo prehlbovanie kvalifik\xE1cie. Obsah mus\xED by\u0165 vypracovan\xFD tak, aby zodpovedal legislat\xEDvnym po\u017Eiadavk\xE1m a aktu\xE1lnemu stavu poznania."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "3.2 Kvalita vzdel\xE1vania"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Kvalita vzdel\xE1vania predstavuje s\xFAbor parametrov, ktor\xFDmi sa hodnot\xED celkov\xE1 \xFArove\u0148 poskytovan\xE9ho vzdelania. Zah\u0155\u0148a odborn\xFA presnos\u0165, legislat\xEDvnu spr\xE1vnos\u0165, technick\xFA kvalitu, didaktick\xFA vhodnos\u0165, pou\u017E\xEDvate\u013Esk\xFA pr\xEDstupnos\u0165 a celkov\xFA pridan\xFA hodnotu pre \xFA\u010Dastn\xEDka."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "3.3 Odborn\xFD garant"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Odborn\xFD garant je osoba, ktor\xE1 zodpoved\xE1 za odborn\xFD doh\u013Ead nad obsahom vzdel\xE1vac\xEDch programov. Jeho \xFAlohou je garantova\u0165, \u017Ee obsah je nielen legislat\xEDvne spr\xE1vny, ale aj odborne aktu\xE1lny, metodicky spr\xE1vne vystavan\xFD a vhodn\xFD pre cie\u013Eov\xFA skupinu."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "3.4 Lektor"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Lektor je odborn\xEDk poveren\xFD pr\xEDpravou a prezentovan\xEDm vzdel\xE1vacieho obsahu. Mus\xED ma\u0165 schopnos\u0165 pren\xE1\u0161a\u0165 odborn\xE9 inform\xE1cie zrozumite\u013En\xFDm sp\xF4sobom, vyu\u017E\xEDva\u0165 didaktick\xE9 met\xF3dy vhodn\xE9 pre vzdel\xE1vanie dospel\xFDch a z\xE1rove\u0148 re\u0161pektova\u0165 v\u0161etky intern\xE9 \u0161tandardy."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "3.5 \xDA\u010Dastn\xEDk"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\xDA\u010Dastn\xEDkom je osoba, ktor\xE1 absolvuje vzdel\xE1vaciu aktivitu. Jeho sp\xE4tn\xE1 v\xE4zba je v\xFDznamn\xFDm prvkom procesu skvalit\u0148ovania vzdel\xE1vania a je systematicky vyhodnocovan\xE1."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "3.6 Evalu\xE1cia"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Evalu\xE1cia predstavuje systematick\xE9 hodnotenie kvality vzdel\xE1vacej aktivity. Cie\u013Eom evalu\xE1cie je z\xEDska\u0165 \xFAdaje o spokojnosti \xFA\u010Dastn\xEDkov, didaktickej \xFArovni, odbornosti lektora, technickej kvalite a pr\xEDnosoch programu."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "4. Zodpovednosti"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "4.1 Odborn\xFD garant"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Odborn\xFD garant je odbornou autoritou pre jednotliv\xE9 oblasti vzdel\xE1vania. Jeho \xFAloha presahuje r\xE1mec form\xE1lneho schva\u013Eovania obsahu \u2013 je garantom odbornosti, metodiky a kvalitat\xEDvnej \xFArovne. Garant:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Duje odborn\xFA presnos\u0165 obsahu v s\xFAlade s pr\xE1vnymi predpismi,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "akt\xEDvne monitoruje legislat\xEDvne zmeny a vyhodnocuje ich dosah na obsah kurzov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "poskytuje lektorom metodick\xE9 vedenie a odborn\xE9 odpor\xFA\u010Dania,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zodpoved\xE1 za to, \u017Ee obsah je vystavan\xFD pod\u013Ea z\xE1sad andragogiky a didaktiky dospel\xFDch,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vedie z\xE1znamy o v\u0161etk\xFDch kontrol\xE1ch a odpor\xFA\u010Daniach na \xFApravy obsahu."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Odborn\xFD garant mus\xED sp\u013A\u0148a\u0165:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vysoko\u0161kolsk\xE9 vzdelanie II. stup\u0148a v odbore relevantnom pre obsah alebo minim\xE1lne 3 roky odbornej praxe,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "bez\xFAhonnos\u0165 (preuk\xE1zan\xE1 \u010Destn\xFDm vyhl\xE1sen\xEDm),"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "udr\u017Eiava\u0165 odborn\xFA zdatnos\u0165 pravideln\xFDm \u0161t\xFAdiom."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "4.2 Lektor"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Lektor je odborn\xE1 a komunika\u010Dn\xE1 opora vzdel\xE1vania. Okrem samotnej prezent\xE1cie m\xE1 povinnos\u0165:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pripravova\u0165 obsah, ktor\xFD je odborne spr\xE1vny, zrozumite\u013En\xFD, v s\xFAlade s\xA0legislat\xEDvou a Autorsk\xFDm z\xE1konom,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "v\xA0pr\xEDpade vzdel\xE1vac\xEDch programov pravidelne konzultova\u0165 obsah s\xA0garantom najm\xE4 pri legislat\xEDvnych zmen\xE1ch,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "reagova\u0165 na hodnotenia \xFA\u010Dastn\xEDkov a zapracova\u0165 odpor\xFA\u010Dania,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "dodr\u017Eiava\u0165 stanoven\xE9 technick\xE9 \u0161tandardy pre prezent\xE1cie a vide\xE1,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Di\u0165, aby v\u0161etky inform\xE1cie boli pod\xE1van\xE9 objekt\xEDvne, vecne a v s\xFAlade s odbornou etikou,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "udr\u017Eiava\u0165 odborn\xFA zdatnos\u0165 pravideln\xFDm \u0161t\xFAdiom."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "4.3 Projektov\xFD mana\u017E\xE9r"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Projektov\xFD mana\u017E\xE9r je organiza\u010Dn\xFDm garantom procesu vzdel\xE1vania. Jeho \xFAlohou je zabezpe\u010Di\u0165 hladk\xFD priebeh v\u0161etk\xFDch f\xE1z vzdel\xE1vacej aktivity. Zodpoved\xE1 najm\xE4 za:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "koordin\xE1ciu intern\xFDch a extern\xFDch spolupracovn\xEDkov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "logistiku, technick\xE9 zabezpe\u010Denie a komunik\xE1ciu s \xFA\u010Dastn\xEDkmi,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "evidenciu v\u0161etk\xFDch dokumentov s\xFAvisiacich s obsahom, schv\xE1leniami, hodnoteniami a aktualiz\xE1ciami,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vyhodnocovanie riz\xEDk a n\xE1vrh n\xE1pravn\xFDch opatren\xED."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "4.4 Technick\xE1 podpora"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Technick\xE1 podpora zabezpe\u010Duje technick\xFA kvalitu vzdel\xE1vania a rie\u0161i technick\xE9 probl\xE9my v re\xE1lnom \u010Dase. Zah\u0155\u0148a najm\xE4:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "kontrolu kvality obrazu, zvuku a funk\u010Dnosti platformy,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pr\xEDpravu technick\xFDch podkladov pre webin\xE1re/online \u0161kolenia a videokurzy,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "archiv\xE1ciu z\xE1znamov a ich bezpe\u010Dn\xE9 ulo\u017Eenie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "rie\u0161enie technick\xFDch komplik\xE1ci\xED po\u010Das vysielania."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "4.5 Z\xE1kazn\xEDcky servis"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Z\xE1kazn\xEDcka podpora pln\xED d\xF4le\u017Eit\xFA \xFAlohu v oblasti komunik\xE1cie s \xFA\u010Dastn\xEDkmi. Zodpoved\xE1 za:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "profesion\xE1lne informovanie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "rie\u0161enie ot\xE1zok,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "prij\xEDmanie podnetov a ich smerovanie na pr\xEDslu\u0161n\xE9 osoby."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Z\xE1rove\u0148 zabezpe\u010Duje, aby \xFA\u010Dastn\xEDci dostali v\u0161etky potrebn\xE9 \xFAdaje v\u010Das a v zrozumite\u013Enej forme."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "5. Proces zabezpe\u010Dovania kvality"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "5.1 Pl\xE1novanie vzdel\xE1vania"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Pl\xE1novanie je strategick\xE1 f\xE1za, ktor\xE1 ur\u010Duje smerovanie celej vzdel\xE1vacej aktivity. V tejto f\xE1ze sa identifikuj\xFA potreby trhu, hodnot\xED konkurencia, zis\u0165uje dopyt a sleduj\xFA legislat\xEDvne zmeny. V\xFDber t\xE9m vych\xE1dza z:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "anal\xFDzy potrieb cie\u013Eov\xFDch skup\xEDn,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "po\u017Eiadaviek legislat\xEDvy,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "trendov v oblasti podnikania, pr\xE1va, personalistiky a ekonomiky,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "sp\xE4tnej v\xE4zby \xFA\u010Dastn\xEDkov predch\xE1dzaj\xFAcich programov, online \u0161kolen\xED, webin\xE1rov, videokurzov, odborn\xFDch konferenci\xED."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "5.2 Tvorba obsahu"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Tvorba obsahu mus\xED by\u0165 systematick\xE1, odborn\xE1 a metodicky spr\xE1vna. Obsah je vytv\xE1ran\xFD v s\xFAlade so z\xE1sadami didaktiky dospel\xFDch a mus\xED by\u0165 jasne \u0161trukt\xFArovan\xFD. Obsah mus\xED obsahova\u0165:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "jasne definovan\xE9 ciele vzdel\xE1vania,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "logick\xFA nadv\xE4znos\u0165 t\xE9m, pr\xEDkladov a v\xFDkladov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "praktick\xE9 pr\xEDklady a aplika\u010Dn\xE9 uk\xE1\u017Eky,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zoznam legislat\xEDvnych zdrojov alebo prelinkovanie na zdroje v\xA0online prezenta\u010Dn\xFDch materi\xE1loch."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "5.3 Realiz\xE1cia vzdel\xE1vania"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Realiz\xE1cia je vykon\xE1vacou f\xE1zou procesu a zah\u0155\u0148a:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "moderovanie podujatia,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "akt\xEDvne riadenie interakcie s \xFA\u010Dastn\xEDkmi,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Denie technicky bezchybn\xE9ho priebehu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "rie\u0161enie kr\xEDzov\xFDch situ\xE1ci\xED (napr. v\xFDpadok techniky, v\xFDpadok internetov\xE9ho pripojenia lektora a\xA0pod.),"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "udr\u017Eiavanie didaktickej a odbornej kvality po\u010Das celej aktivity."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "5.4 Hodnotenie kvality (Evalu\xE1cia)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Evalu\xE1cia je d\xF4le\u017Eitou s\xFA\u010Das\u0165ou kvality. Systematicky sa zbieraj\xFA \xFAdaje od \xFA\u010Dastn\xEDkov, lektorov aj technick\xE9ho t\xEDmu. Dotazn\xEDky hodnotia:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "odborn\xFA \xFArove\u0148 lektora,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "jasnos\u0165 v\xFDkladu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pr\xEDnos obsahu pre prax,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "technick\xFA kvalitu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "celkov\xFA spokojnos\u0165."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["V\xFDsledky evalu\xE1cie sa n\xE1sledne premietaj\xFA do pl\xE1nu aktualiz\xE1ci\xED alebo korek\u010Dn\xFDch opatren\xED minim\xE1lne ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "raz ro\u010Dne"
      }), "."]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "6. Riadenie zmien a aktualiz\xE1ci\xED"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Riadenie zmien je s\xFA\u010Das\u0165ou kvalitn\xE9ho vzdel\xE1vania. Vzh\u013Eadom na dynamickos\u0165 legislat\xEDvy aj praxe je potrebn\xE9 obsah pravidelne upravova\u0165:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: ["obsah kurzov sa pravidelne monitoruje a aktualizuje minim\xE1lne ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "raz ro\u010Dne"
        }), ","]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "legislat\xEDvne kurzy sa aktualizuj\xFA v\u017Edy pri zmene relevantnej legislat\xEDvy,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "projektov\xFD mana\u017E\xE9r zabezpe\u010Duje z\xE1znam o v\u0161etk\xFDch vykonan\xFDch aktualiz\xE1ci\xE1ch,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "aktualiz\xE1cie vzdel\xE1vac\xEDch programov podliehaj\xFA schv\xE1leniu odborn\xE9ho garanta."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "7. Evidencia a dokument\xE1cia"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Evidencia je veden\xE1 v internom syst\xE9me PP a mus\xED by\u0165 \xFApln\xE1, presn\xE1 a bezpe\u010Dne ulo\u017Een\xE1. Dokument\xE1cia (obsahy kurzov, zmenov\xE9 z\xE1znamy, hodnotenia) je z\xE1kladn\xFDm zdrojom pre intern\xE9 audity a kontroly. Pr\xEDstup k dokumentom je riaden\xFD pod\u013Ea intern\xFDch pr\xE1vomoc\xED."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "8. Podpora \xFA\u010Dastn\xEDkov a rie\u0161enie podnetov"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Podpora \xFA\u010Dastn\xEDkov je d\xF4le\u017Eit\xFDm prvkom kvality. Ka\u017Ed\xFD \xFA\u010Dastn\xEDk m\xE1 pr\xE1vo na profesion\xE1lnu a v\u010Dasn\xFA odpove\u010F na ot\xE1zky \u010Di podnety:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "\xFA\u010Dastn\xEDci m\xF4\u017Eu pod\xE1va\u0165 podnety prostredn\xEDctvom e-mailu, formul\xE1ra \u010Di telefonicky,"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: ["podnety sa eviduj\xFA a rie\u0161ia v lehote do ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "5 pracovn\xFDch dn\xED"
        }), "."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "V pr\xEDpade s\u0165a\u017Enost\xED mana\u017E\xE9r slu\u017Eieb z\xE1kazn\xEDkom vykon\xE1 anal\xFDzu, navrhne rie\u0161enie a informuje z\xFA\u010Dastnen\xE9 strany."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "9. Kontrola dodr\u017Eiavania smernice"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Dodr\u017Eiavanie smernice sa pravidelne kontroluje intern\xFDm auditom. Audit posudzuje procesy, dokumenty, z\xE1znamy a v\xFDsledky \u0161kolen\xED:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "kontrolu vykon\xE1va poveren\xE1 osoba z vedenia spolo\u010Dnosti,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "minim\xE1lne raz ro\u010Dne sa uskuto\u010Dn\xED intern\xFD audit kvality vzdel\xE1vania,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zistenia auditu sa dokumentuj\xFA a prij\xEDmaj\xFA sa n\xE1pravn\xE9 opatrenia."
      })]
    })]
  });
};

/* harmony default export */ var EducationQualityManagementSystem_EducationQualityManagementSystem = (EducationQualityManagementSystemTemplate);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(94951);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
;// CONCATENATED MODULE: ./src/pages/system-riadenia-kvality-vzdelavania.tsx










var EducationQualityManagementSystem = function EducationQualityManagementSystem() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(EducationQualityManagementSystem_EducationQualityManagementSystem, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var system_riadenia_kvality_vzdelavania = (EducationQualityManagementSystem);

/***/ }),

/***/ 34255:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system-riadenia-kvality-vzdelavania",
      function () {
        return __webpack_require__(77349);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77191:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectDestructuringEmpty; }
/* harmony export */ });
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

/***/ }),

/***/ 90116:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(28811);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,iterableToArray/* default */.Z)(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4623,9774,2888,179], function() { return __webpack_exec__(34255); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);